module.exports = __webpack_public_path__ + "img/recharge_active.006bbdc9.png";